<div class="mfa-setup-container">
    <div class="header">
        <div class="header-text">
          <h1>Link Authentication App</h1>
          <p [innerHTML]="helpText"></p>
        </div>
      </div>
  <div class="qr-code-card">

    <div class="qr-code-area">
       
          <!-- QR Code -->
          <qrcode
            class="qr-code"
            [qrdata]="qrCodeValue"
            [width]="qrCodeDimension"
            [errorCorrectionLevel]="'M'"
          ></qrcode>
      
          <!-- Backup Secret Code -->
          <div class="secret-code-box">
            <p>Add the set up code in your authentication app</p>
            <div
            class="secret-code"
            [ngClass]="{ 'show-on-mobile': showSecretCodeOnMobile }"
          >
          <div class="code-line">
            <span *ngFor="let codeSegment of getFormattedSecretCode().slice(0, (getFormattedSecretCode().length + 1) / 2)">
              {{ codeSegment }}
            </span>
          </div>
          <div class="code-line">
            <span *ngFor="let codeSegment of getFormattedSecretCode().slice( (getFormattedSecretCode().length +1) / 2)">
              {{ codeSegment }}
            </span>
          </div>
          </div>
  
          <!-- Mobile-friendly actions -->
          <div class="mobile-actions">
            <button class="btn-copy" (click)="copySecretCode()">
              @if(copiedToClipboard){
                <div class="copied-message">
                  Copied to clipboard!
                </div>
              }@else{
                Copy Code
              }
              
              </button>
            <button class="btn-view" (click)="toggleViewCode()">
              {{ showSecretCodeOnMobile ? 'Hide Code' : 'View Code' }}
            </button>
          </div>
        </div>
    </div>
    
    <button class="btn btn-primary" (click)="proceedToNextStep()">Next</button>
  </div>
</div>
